module.exports = __webpack_public_path__ + "cf862c3fd4ae1023ba106fbbf3eec68a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/zombie-glasses-s.png
// module id = 1865
// module chunks = 0